/** Copy of the `/tax-exemption` heading (`components/TaxExemptionPage/index.tsx`). */
import { LanguageContent } from "@ryerson/frontend.common";

/** One language's title and instruction line. */
export interface TaxExemptionPageLabels {
	title: string;
	subTitle: string;
}

/** The heading copy by language. */
export const withLanguage: LanguageContent<TaxExemptionPageLabels> = {
	en: {
		title: "Tax Exemption",
		subTitle:
			"Do you have a tax exemption certificate? If so, please fill out this form, upload your document and click submit.",
	},
	fr: {
		title: "Exemption fiscale",
		subTitle:
			"Possédez-vous un certificat d’exonération d’impôt? Le cas échéant, remplissez ce formulaire, téléversez votre document, puis cliquez sur le bouton de soumission.",
	},
	es: {
		title: "Exención fiscal",
		subTitle:
			"¿Tienes un certificado de exención de impuestos? Si es así, completa este formulario, sube tu documento y haz clic en enviar.",
	},
};
